
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FooterComponent',
  props: {
    mediaSize: {
      type: Number,
      default: 48,
      required: false
    }
  },
  data: () => ({
    socialsMedia: [
      { name: 'Linkedin', icon: 'linkedin', url: 'https://www.linkedin.com/in/diego-perez-2055-arg/'},
      { name: 'Github', icon: 'github', url: 'https://github.com/dforce2055'},
    ]
  }),
});
